import { IconName } from '../../Icon/Icon';
// Defines a comprehensive list of all available icon names used throughout the application, primarily for the IconPicker component. This array ensures consistent and valid icon references.
export const ICON_LIST: IconName[] = [
  'zoom-out',
  'zoom-in',
  'zap',
  'zap-off',
  'youtube',
  'x',
  'wrench',
  'worm',
  'workflow',
  'wine',
  'wine-off',
  'wind',
  'wind-arrow-down',
  'wifi',
  'wifi-zero',
  'wifi-sync',
  'wifi-pen',
  'wifi-off',
  'wifi-low',
  'wifi-high',
  'wifi-cog',
  'whole-word',
  'wheat',
  'wheat-off',
  'weight',
  'weight-tilde',
  'webhook',
  'webhook-off',
  'webcam',
  'waypoints',
  'waves',
  'waves-ladder',
  'waves-arrow-up',
  'waves-arrow-down',
  'watch',
  'washing-machine',
  'warehouse',
  'wand',
  'wand-sparkles',
  'wallpaper',
  'wallet',
  'wallet-minimal',
  'wallet-cards',
  'vote',
  'volume',
  'volume-x',
  'volume-off',
  'volume-2',
  'volume-1',
  'volleyball',
  'voicemail',
  'view',
  'videotape',
  'video',
  'video-off',
  'vibrate',
  'vibrate-off',
  'venus',
  'venus-and-mars',
  'venetian-mask',
  'vegan',
  'vector-square',
  'vault',
  'variable',
  'van',
  'utility-pole',
  'utensils',
  'utensils-crossed',
  'users',
  'users-round',
  'user',
  'user-x',
  'user-star',
  'user-search',
  'user-round',
  'user-round-x',
  'user-round-search',
  'user-round-plus',
  'user-round-pen',
  'user-round-minus',
  'user-round-cog',
  'user-round-check',
  'user-plus',
  'user-pen',
  'user-minus',
  'user-lock',
  'user-cog',
  'user-check',
  'usb',
  'upload',
  'unplug',
  'unlink',
  'unlink-2',
  'university',
  'ungroup',
  'unfold-vertical',
  'unfold-horizontal',
  'undo',
  'undo-dot',
  'undo-2',
  'underline',
  'umbrella',
  'umbrella-off',
  'type',
  'type-outline',
  'twitter',
  'twitch',
  'tv',
  'tv-minimal',
  'tv-minimal-play',
  'turtle',
  'turntable',
  'turkish-lira',
  'truck',
  'truck-electric',
  'trophy',
  'triangle',
  'triangle-right',
  'triangle-dashed',
  'triangle-alert',
  'trending-up',
  'trending-up-down',
  'trending-down',
  'trello',
  'trees',
  'tree-pine',
  'tree-palm',
  'tree-deciduous',
  'trash',
  'trash-2',
  'transgender',
  'tram-front',
  'train-track',
  'train-front',
  'train-front-tunnel',
  'traffic-cone',
  'tractor',
  'toy-brick',
  'tower-control',
  'touchpad',
  'touchpad-off',
  'torus',
  'tornado',
  'toolbox',
  'tool-case',
  'toilet',
  'toggle-right',
  'toggle-left',
  'timer',
  'timer-reset',
  'timer-off',
  'tickets',
  'tickets-plane',
  'ticket',
  'ticket-x',
  'ticket-slash',
  'ticket-plus',
  'ticket-percent',
  'ticket-minus',
  'ticket-check',
  'thumbs-up',
  'thumbs-down',
  'thermometer',
  'thermometer-sun',
  'thermometer-snowflake',
  'theater',
  'text-wrap',
  'text-select',
  'text-search',
  'text-quote',
  'text-initial',
  'text-cursor',
  'text-cursor-input',
  'text-align-start',
  'text-align-justify',
  'text-align-end',
  'text-align-center',
  'test-tubes',
  'test-tube',
  'test-tube-diagonal',
  'terminal',
  'tent',
  'tent-tree',
  'telescope',
  'target',
  'tangent',
  'tally-5',
  'tally-4',
  'tally-3',
  'tally-2',
  'tally-1',
  'tags',
  'tag',
  'tablets',
  'tablet',
  'tablet-smartphone',
  'table',
  'table-rows-split',
  'table-properties',
  'table-of-contents',
  'table-columns-split',
  'table-cells-split',
  'table-cells-merge',
  'table-2',
  'syringe',
  'swords',
  'sword',
  'switch-camera',
  'swiss-franc',
  'swatch-book',
  'superscript',
  'sunset',
  'sunrise',
  'sun',
  'sun-snow',
  'sun-moon',
  'sun-medium',
  'sun-dim',
  'subscript',
  'strikethrough',
  'stretch-vertical',
  'stretch-horizontal',
  'store',
  'stone',
  'sticky-note',
  'sticker',
  'stethoscope',
  'step-forward',
  'step-back',
  'star',
  'star-off',
  'star-half',
  'stamp',
  'squirrel',
  'squircle',
  'squircle-dashed',
  'squares-unite',
  'squares-subtract',
  'squares-intersect',
  'squares-exclude',
  'square',
  'square-x',
  'square-user',
  'square-user-round',
  'square-terminal',
  'square-stop',
  'square-star',
  'square-stack',
  'square-square',
  'square-split-vertical',
  'square-split-horizontal',
  'square-slash',
  'square-sigma',
  'square-scissors',
  'square-round-corner',
  'square-radical',
  'square-power',
  'square-plus',
  'square-play',
  'square-pilcrow',
  'square-pi',
  'square-percent',
  'square-pen',
  'square-pause',
  'square-parking',
  'square-parking-off',
  'square-mouse-pointer',
  'square-minus',
  'square-menu',
  'square-m',
  'square-library',
  'square-kanban',
  'square-function',
  'square-equal',
  'square-dot',
  'square-divide',
  'square-dashed',
  'square-dashed-top-solid',
  'square-dashed-mouse-pointer',
  'square-dashed-kanban',
  'square-dashed-bottom',
  'square-dashed-bottom-code',
  'square-code',
  'square-chevron-up',
  'square-chevron-right',
  'square-chevron-left',
  'square-chevron-down',
  'square-check',
  'square-check-big',
  'square-chart-gantt',
  'square-bottom-dashed-scissors',
  'square-asterisk',
  'square-arrow-up',
  'square-arrow-up-right',
  'square-arrow-up-left',
  'square-arrow-right',
  'square-arrow-out-up-right',
  'square-arrow-out-up-left',
  'square-arrow-out-down-right',
  'square-arrow-out-down-left',
  'square-arrow-left',
  'square-arrow-down',
  'square-arrow-down-right',
  'square-arrow-down-left',
  'square-activity',
  'sprout',
  'spray-can',
  'spotlight',
  'spool',
  'split',
  'spline',
  'spline-pointer',
  'spell-check',
  'spell-check-2',
  'speech',
  'speaker',
  'sparkles',
  'sparkle',
  'spade',
  'space',
  'soup',
  'solar-panel',
  'sofa',
  'soap-dispenser-droplet',
  'snowflake',
  'snail',
  'smile',
  'smile-plus',
  'smartphone',
  'smartphone-nfc',
  'smartphone-charging',
  'sliders-vertical',
  'sliders-horizontal',
  'slice',
  'slash',
  'slack',
  'skull',
  'skip-forward',
  'skip-back',
  'siren',
  'signpost',
  'signpost-big',
  'signature',
  'signal',
  'signal-zero',
  'signal-medium',
  'signal-low',
  'signal-high',
  'sigma',
  'shuffle',
  'shrub',
  'shrink',
  'shrimp',
  'shredder',
  'shower-head',
  'shovel',
  'shopping-cart',
  'shopping-basket',
  'shopping-bag',
  'shirt',
  'ship',
  'ship-wheel',
  'shield',
  'shield-x',
  'shield-user',
  'shield-question-mark',
  'shield-plus',
  'shield-off',
  'shield-minus',
  'shield-half',
  'shield-ellipsis',
  'shield-check',
  'shield-ban',
  'shield-alert',
  'shell',
  'sheet',
  'share',
  'share-2',
  'shapes',
  'settings',
  'settings-2',
  'server',
  'server-off',
  'server-crash',
  'server-cog',
  'separator-vertical',
  'separator-horizontal',
  'send',
  'send-to-back',
  'send-horizontal',
  'section',
  'search',
  'search-x',
  'search-slash',
  'search-code',
  'search-check',
  'search-alert',
  'scroll',
  'scroll-text',
  'screen-share',
  'screen-share-off',
  'scooter',
  'scissors',
  'scissors-line-dashed',
  'school',
  'scan',
  'scan-text',
  'scan-search',
  'scan-qr-code',
  'scan-line',
  'scan-heart',
  'scan-face',
  'scan-eye',
  'scan-barcode',
  'scaling',
  'scale',
  'scale-3d',
  'save',
  'save-off',
  'save-all',
  'saudi-riyal',
  'satellite',
  'satellite-dish',
  'sandwich',
  'salad',
  'sailboat',
  'russian-ruble',
  'ruler',
  'ruler-dimension-line',
  'rss',
  'rows-4',
  'rows-3',
  'rows-2',
  'router',
  'route',
  'route-off',
  'rotate-cw',
  'rotate-cw-square',
  'rotate-ccw',
  'rotate-ccw-square',
  'rotate-ccw-key',
  'rotate-3d',
  'rose',
  'roller-coaster',
  'rocking-chair',
  'rocket',
  'ribbon',
  'rewind',
  'reply',
  'reply-all',
  'replace',
  'replace-all',
  'repeat',
  'repeat-2',
  'repeat-1',
  'remove-formatting',
  'regex',
  'refrigerator',
  'refresh-cw',
  'refresh-cw-off',
  'refresh-ccw',
  'refresh-ccw-dot',
  'redo',
  'redo-dot',
  'redo-2',
  'recycle',
  'rectangle-vertical',
  'rectangle-horizontal',
  'rectangle-goggles',
  'rectangle-ellipsis',
  'rectangle-circle',
  'receipt',
  'receipt-turkish-lira',
  'receipt-text',
  'receipt-swiss-franc',
  'receipt-russian-ruble',
  'receipt-pound-sterling',
  'receipt-japanese-yen',
  'receipt-indian-rupee',
  'receipt-euro',
  'receipt-cent',
  'ratio',
  'rat',
  'rainbow',
  'rail-symbol',
  'radius',
  'radio',
  'radio-tower',
  'radio-receiver',
  'radical',
  'radiation',
  'radar',
  'rabbit',
  'quote',
  'qr-code',
  'pyramid',
  'puzzle',
  'proportions',
  'projector',
  'printer',
  'printer-check',
  'presentation',
  'power',
  'power-off',
  'pound-sterling',
  'popsicle',
  'popcorn',
  'pointer',
  'pointer-off',
  'podcast',
  'pocket',
  'pocket-knife',
  'plus',
  'plug',
  'plug-zap',
  'plug-2',
  'play',
  'plane',
  'plane-takeoff',
  'plane-landing',
  'pizza',
  'pipette',
  'pin',
  'pin-off',
  'pill',
  'pill-bottle',
  'pilcrow',
  'pilcrow-right',
  'pilcrow-left',
  'piggy-bank',
  'picture-in-picture',
  'picture-in-picture-2',
  'pickaxe',
  'piano',
  'pi',
  'phone',
  'phone-outgoing',
  'phone-off',
  'phone-missed',
  'phone-incoming',
  'phone-forwarded',
  'phone-call',
  'philippine-peso',
  'person-standing',
  'percent',
  'pentagon',
  'pencil',
  'pencil-ruler',
  'pencil-off',
  'pencil-line',
  'pen',
  'pen-tool',
  'pen-off',
  'pen-line',
  'pc-case',
  'paw-print',
  'pause',
  'party-popper',
  'parking-meter',
  'parentheses',
  'paperclip',
  'panels-top-left',
  'panels-right-bottom',
  'panels-left-bottom',
  'panel-top',
  'panel-top-open',
  'panel-top-dashed',
  'panel-top-close',
  'panel-top-bottom-dashed',
  'panel-right',
  'panel-right-open',
  'panel-right-dashed',
  'panel-right-close',
  'panel-left',
  'panel-left-right-dashed',
  'panel-left-open',
  'panel-left-dashed',
  'panel-left-close',
  'panel-bottom',
  'panel-bottom-open',
  'panel-bottom-dashed',
  'panel-bottom-close',
  'panda',
  'palette',
  'paintbrush',
  'paintbrush-vertical',
  'paint-roller',
  'paint-bucket',
  'package',
  'package-x',
  'package-search',
  'package-plus',
  'package-open',
  'package-minus',
  'package-check',
  'package-2',
  'origami',
  'orbit',
  'option',
  'omega',
  'octagon',
  'octagon-x',
  'octagon-pause',
  'octagon-minus',
  'octagon-alert',
  'nut',
  'nut-off',
  'notepad-text',
  'notepad-text-dashed',
  'notebook',
  'notebook-text',
  'notebook-tabs',
  'notebook-pen',
  'non-binary',
  'nfc',
  'newspaper',
  'network',
  'navigation',
  'navigation-off',
  'navigation-2',
  'navigation-2-off',
  'music',
  'music-4',
  'music-3',
  'music-2',
  'move',
  'move-vertical',
  'move-up',
  'move-up-right',
  'move-up-left',
  'move-right',
  'move-left',
  'move-horizontal',
  'move-down',
  'move-down-right',
  'move-down-left',
  'move-diagonal',
  'move-diagonal-2',
  'move-3d',
  'mouse',
  'mouse-pointer',
  'mouse-pointer-click',
  'mouse-pointer-ban',
  'mouse-pointer-2',
  'mouse-pointer-2-off',
  'mouse-off',
  'mountain',
  'mountain-snow',
  'motorbike',
  'moon',
  'moon-star',
  'monitor',
  'monitor-x',
  'monitor-up',
  'monitor-stop',
  'monitor-speaker',
  'monitor-smartphone',
  'monitor-play',
  'monitor-pause',
  'monitor-off',
  'monitor-down',
  'monitor-dot',
  'monitor-cog',
  'monitor-cloud',
  'monitor-check',
  'minus',
  'minimize',
  'minimize-2',
  'milk',
  'milk-off',
  'milestone',
  'microwave',
  'microscope',
  'microchip',
  'mic',
  'mic-vocal',
  'mic-off',
  'messages-square',
  'message-square',
  'message-square-x',
  'message-square-warning',
  'message-square-text',
  'message-square-share',
  'message-square-reply',
  'message-square-quote',
  'message-square-plus',
  'message-square-off',
  'message-square-more',
  'message-square-lock',
  'message-square-heart',
  'message-square-dot',
  'message-square-diff',
  'message-square-dashed',
  'message-square-code',
  'message-circle',
  'message-circle-x',
  'message-circle-warning',
  'message-circle-reply',
  'message-circle-question-mark',
  'message-circle-plus',
  'message-circle-off',
  'message-circle-more',
  'message-circle-heart',
  'message-circle-dashed',
  'message-circle-code',
  'merge',
  'menu',
  'memory-stick',
  'meh',
  'megaphone',
  'megaphone-off',
  'medal',
  'maximize',
  'maximize-2',
  'martini',
  'mars',
  'mars-stroke',
  'map',
  'map-plus',
  'map-pinned',
  'map-pin',
  'map-pin-x',
  'map-pin-x-inside',
  'map-pin-plus',
  'map-pin-plus-inside',
  'map-pin-pen',
  'map-pin-off',
  'map-pin-minus',
  'map-pin-minus-inside',
  'map-pin-house',
  'map-pin-check',
  'map-pin-check-inside',
  'map-minus',
  'mails',
  'mailbox',
  'mail',
  'mail-x',
  'mail-warning',
  'mail-search',
  'mail-question-mark',
  'mail-plus',
  'mail-open',
  'mail-minus',
  'mail-check',
  'magnet',
  'luggage',
  'lollipop',
  'logs',
  'log-out',
  'log-in',
  'lock',
  'lock-open',
  'lock-keyhole',
  'lock-keyhole-open',
  'locate',
  'locate-off',
  'locate-fixed',
  'loader',
  'loader-pinwheel',
  'loader-circle',
  'list',
  'list-x',
  'list-video',
  'list-tree',
  'list-todo',
  'list-start',
  'list-restart',
  'list-plus',
  'list-ordered',
  'list-music',
  'list-minus',
  'list-indent-increase',
  'list-indent-decrease',
  'list-filter',
  'list-filter-plus',
  'list-end',
  'list-collapse',
  'list-chevrons-up-down',
  'list-chevrons-down-up',
  'list-checks',
  'list-check',
  'linkedin',
  'link',
  'link-2',
  'link-2-off',
  'line-squiggle',
  'lightbulb',
  'lightbulb-off',
  'ligature',
  'life-buoy',
  'library',
  'library-big',
  'lectern',
  'leafy-green',
  'leaf',
  'layout-template',
  'layout-panel-top',
  'layout-panel-left',
  'layout-list',
  'layout-grid',
  'layout-dashboard',
  'layers',
  'layers-plus',
  'layers-2',
  'laugh',
  'lasso',
  'lasso-select',
  'laptop',
  'laptop-minimal',
  'laptop-minimal-check',
  'languages',
  'landmark',
  'land-plot',
  'lamp',
  'lamp-wall-up',
  'lamp-wall-down',
  'lamp-floor',
  'lamp-desk',
  'lamp-ceiling',
  'keyboard',
  'keyboard-off',
  'keyboard-music',
  'key',
  'key-square',
  'key-round',
  'kayak',
  'kanban',
  'joystick',
  'japanese-yen',
  'iteration-cw',
  'iteration-ccw',
  'italic',
  'instagram',
  'inspection-panel',
  'info',
  'infinity',
  'indian-rupee',
  'inbox',
  'import',
  'images',
  'image',
  'image-upscale',
  'image-up',
  'image-plus',
  'image-play',
  'image-off',
  'image-minus',
  'image-down',
  'id-card',
  'id-card-lanyard',
  'ice-cream-cone',
  'ice-cream-bowl',
  'house',
  'house-wifi',
  'house-plus',
  'house-plug',
  'house-heart',
  'hourglass',
  'hotel',
  'hospital',
  'hop',
  'hop-off',
  'history',
  'highlighter',
  'hexagon',
  'helicopter',
  'heater',
  'heart',
  'heart-pulse',
  'heart-plus',
  'heart-off',
  'heart-minus',
  'heart-handshake',
  'heart-crack',
  'headset',
  'headphones',
  'headphone-off',
  'heading',
  'heading-6',
  'heading-5',
  'heading-4',
  'heading-3',
  'heading-2',
  'heading-1',
  'hdmi-port',
  'hd',
  'haze',
  'hat-glasses',
  'hash',
  'hard-hat',
  'hard-drive',
  'hard-drive-upload',
  'hard-drive-download',
  'handshake',
  'handbag',
  'hand',
  'hand-platter',
  'hand-metal',
  'hand-helping',
  'hand-heart',
  'hand-grab',
  'hand-fist',
  'hand-coins',
  'hammer',
  'hamburger',
  'ham',
  'guitar',
  'group',
  'grip',
  'grip-vertical',
  'grip-horizontal',
  'grid-3x3',
  'grid-3x2',
  'grid-2x2',
  'grid-2x2-x',
  'grid-2x2-plus',
  'grid-2x2-check',
  'grape',
  'graduation-cap',
  'gpu',
  'goal',
  'globe',
  'globe-lock',
  'glasses',
  'glass-water',
  'gitlab',
  'github',
  'git-pull-request',
  'git-pull-request-draft',
  'git-pull-request-create',
  'git-pull-request-create-arrow',
  'git-pull-request-closed',
  'git-pull-request-arrow',
  'git-merge',
  'git-graph',
  'git-fork',
  'git-compare',
  'git-compare-arrows',
  'git-commit-vertical',
  'git-commit-horizontal',
  'git-branch',
  'git-branch-plus',
  'git-branch-minus',
  'gift',
  'ghost',
  'georgian-lari',
  'gem',
  'gavel',
  'gauge',
  'gamepad',
  'gamepad-directional',
  'gamepad-2',
  'gallery-vertical',
  'gallery-vertical-end',
  'gallery-thumbnails',
  'gallery-horizontal',
  'gallery-horizontal-end',
  'funnel',
  'funnel-x',
  'funnel-plus',
  'fullscreen',
  'fuel',
  'frown',
  'framer',
  'frame',
  'forward',
  'form',
  'forklift',
  'footprints',
  'folders',
  'folder',
  'folder-x',
  'folder-up',
  'folder-tree',
  'folder-sync',
  'folder-symlink',
  'folder-search',
  'folder-search-2',
  'folder-root',
  'folder-plus',
  'folder-pen',
  'folder-output',
  'folder-open',
  'folder-open-dot',
  'folder-minus',
  'folder-lock',
  'folder-key',
  'folder-kanban',
  'folder-input',
  'folder-heart',
  'folder-git',
  'folder-git-2',
  'folder-down',
  'folder-dot',
  'folder-cog',
  'folder-code',
  'folder-closed',
  'folder-clock',
  'folder-check',
  'folder-archive',
  'fold-vertical',
  'fold-horizontal',
  'focus',
  'flower',
  'flower-2',
  'flip-vertical',
  'flip-vertical-2',
  'flip-horizontal',
  'flip-horizontal-2',
  'flask-round',
  'flask-conical',
  'flask-conical-off',
  'flashlight',
  'flashlight-off',
  'flame',
  'flame-kindling',
  'flag',
  'flag-triangle-right',
  'flag-triangle-left',
  'flag-off',
  'fishing-hook',
  'fish',
  'fish-symbol',
  'fish-off',
  'fire-extinguisher',
  'fingerprint-pattern',
  'film',
  'files',
  'file',
  'file-x',
  'file-x-corner',
  'file-volume',
  'file-video-camera',
  'file-user',
  'file-up',
  'file-type',
  'file-type-corner',
  'file-text',
  'file-terminal',
  'file-symlink',
  'file-stack',
  'file-spreadsheet',
  'file-sliders',
  'file-signal',
  'file-search',
  'file-search-corner',
  'file-scan',
  'file-question-mark',
  'file-plus',
  'file-plus-corner',
  'file-play',
  'file-pen',
  'file-pen-line',
  'file-output',
  'file-music',
  'file-minus',
  'file-minus-corner',
  'file-lock',
  'file-key',
  'file-input',
  'file-image',
  'file-heart',
  'file-headphone',
  'file-exclamation-point',
  'file-down',
  'file-digit',
  'file-diff',
  'file-cog',
  'file-code',
  'file-code-corner',
  'file-clock',
  'file-check',
  'file-check-corner',
  'file-chart-pie',
  'file-chart-line',
  'file-chart-column',
  'file-chart-column-increasing',
  'file-braces',
  'file-braces-corner',
  'file-box',
  'file-badge',
  'file-axis-3d',
  'file-archive',
  'figma',
  'ferris-wheel',
  'fence',
  'feather',
  'fast-forward',
  'fan',
  'factory',
  'facebook',
  'eye',
  'eye-off',
  'eye-closed',
  'external-link',
  'expand',
  'ev-charger',
  'euro',
  'ethernet-port',
  'eraser',
  'equal',
  'equal-not',
  'equal-approximately',
  'ellipsis',
  'ellipsis-vertical',
  'egg',
  'egg-off',
  'egg-fried',
  'eclipse',
  'earth',
  'earth-lock',
  'ear',
  'ear-off',
  'dumbbell',
  'drumstick',
  'drum',
  'droplets',
  'droplet',
  'droplet-off',
  'drone',
  'drill',
  'dribbble',
  'drama',
  'drafting-compass',
  'download',
  'dot',
  'door-open',
  'door-closed',
  'door-closed-locked',
  'donut',
  'dollar-sign',
  'dog',
  'dock',
  'dna',
  'dna-off',
  'divide',
  'disc',
  'disc-album',
  'disc-3',
  'disc-2',
  'diff',
  'dices',
  'dice-6',
  'dice-5',
  'dice-4',
  'dice-3',
  'dice-2',
  'dice-1',
  'diamond',
  'diamond-plus',
  'diamond-percent',
  'diamond-minus',
  'diameter',
  'dessert',
  'delete',
  'decimals-arrow-right',
  'decimals-arrow-left',
  'database',
  'database-zap',
  'database-backup',
  'dam',
  'cylinder',
  'currency',
  'cup-soda',
  'cuboid',
  'crown',
  'crosshair',
  'cross',
  'crop',
  'croissant',
  'credit-card',
  'creative-commons',
  'cpu',
  'corner-up-right',
  'corner-up-left',
  'corner-right-up',
  'corner-right-down',
  'corner-left-up',
  'corner-left-down',
  'corner-down-right',
  'corner-down-left',
  'copyright',
  'copyleft',
  'copy',
  'copy-x',
  'copy-slash',
  'copy-plus',
  'copy-minus',
  'copy-check',
  'cooking-pot',
  'cookie',
  'contrast',
  'container',
  'contact',
  'contact-round',
  'construction',
  'cone',
  'concierge-bell',
  'computer',
  'component',
  'compass',
  'command',
  'combine',
  'columns-4',
  'columns-3',
  'columns-3-cog',
  'columns-2',
  'coins',
  'cog',
  'coffee',
  'codesandbox',
  'codepen',
  'code',
  'code-xml',
  'club',
  'clover',
  'cloudy',
  'cloud',
  'cloud-upload',
  'cloud-sync',
  'cloud-sun',
  'cloud-sun-rain',
  'cloud-snow',
  'cloud-rain',
  'cloud-rain-wind',
  'cloud-off',
  'cloud-moon',
  'cloud-moon-rain',
  'cloud-lightning',
  'cloud-hail',
  'cloud-fog',
  'cloud-drizzle',
  'cloud-download',
  'cloud-cog',
  'cloud-check',
  'cloud-backup',
  'cloud-alert',
  'closed-caption',
  'clock',
  'clock-plus',
  'clock-fading',
  'clock-check',
  'clock-arrow-up',
  'clock-arrow-down',
  'clock-alert',
  'clock-9',
  'clock-8',
  'clock-7',
  'clock-6',
  'clock-5',
  'clock-4',
  'clock-3',
  'clock-2',
  'clock-12',
  'clock-11',
  'clock-10',
  'clock-1',
  'clipboard',
  'clipboard-x',
  'clipboard-type',
  'clipboard-plus',
  'clipboard-pen',
  'clipboard-pen-line',
  'clipboard-paste',
  'clipboard-minus',
  'clipboard-list',
  'clipboard-copy',
  'clipboard-clock',
  'clipboard-check',
  'clapperboard',
  'citrus',
  'circuit-board',
  'circle',
  'circle-x',
  'circle-user',
  'circle-user-round',
  'circle-stop',
  'circle-star',
  'circle-small',
  'circle-slash',
  'circle-slash-2',
  'circle-question-mark',
  'circle-power',
  'circle-pound-sterling',
  'circle-plus',
  'circle-play',
  'circle-pile',
  'circle-percent',
  'circle-pause',
  'circle-parking',
  'circle-parking-off',
  'circle-off',
  'circle-minus',
  'circle-gauge',
  'circle-fading-plus',
  'circle-fading-arrow-up',
  'circle-equal',
  'circle-ellipsis',
  'circle-dot',
  'circle-dot-dashed',
  'circle-dollar-sign',
  'circle-divide',
  'circle-dashed',
  'circle-chevron-up',
  'circle-chevron-right',
  'circle-chevron-left',
  'circle-chevron-down',
  'circle-check',
  'circle-check-big',
  'circle-arrow-up',
  'circle-arrow-right',
  'circle-arrow-out-up-right',
  'circle-arrow-out-up-left',
  'circle-arrow-out-down-right',
  'circle-arrow-out-down-left',
  'circle-arrow-left',
  'circle-arrow-down',
  'circle-alert',
  'cigarette',
  'cigarette-off',
  'church',
  'chromium',
  'chevrons-up',
  'chevrons-up-down',
  'chevrons-right',
  'chevrons-right-left',
  'chevrons-left',
  'chevrons-left-right',
  'chevrons-left-right-ellipsis',
  'chevrons-down',
  'chevrons-down-up',
  'chevron-up',
  'chevron-right',
  'chevron-left',
  'chevron-last',
  'chevron-first',
  'chevron-down',
  'chess-rook',
  'chess-queen',
  'chess-pawn',
  'chess-knight',
  'chess-king',
  'chess-bishop',
  'cherry',
  'chef-hat',
  'check',
  'check-line',
  'check-check',
  'chart-spline',
  'chart-scatter',
  'chart-pie',
  'chart-no-axes-gantt',
  'chart-no-axes-combined',
  'chart-no-axes-column',
  'chart-no-axes-column-increasing',
  'chart-no-axes-column-decreasing',
  'chart-network',
  'chart-line',
  'chart-gantt',
  'chart-column',
  'chart-column-stacked',
  'chart-column-increasing',
  'chart-column-decreasing',
  'chart-column-big',
  'chart-candlestick',
  'chart-bar',
  'chart-bar-stacked',
  'chart-bar-increasing',
  'chart-bar-decreasing',
  'chart-bar-big',
  'chart-area',
  'cctv',
  'cat',
  'castle',
  'cast',
  'cassette-tape',
  'case-upper',
  'case-sensitive',
  'case-lower',
  'carrot',
  'card-sim',
  'caravan',
  'car',
  'car-taxi-front',
  'car-front',
  'captions',
  'captions-off',
  'cannabis',
  'cannabis-off',
  'candy',
  'candy-off',
  'candy-cane',
  'camera',
  'camera-off',
  'calendars',
  'calendar',
  'calendar-x',
  'calendar-x-2',
  'calendar-sync',
  'calendar-search',
  'calendar-range',
  'calendar-plus',
  'calendar-plus-2',
  'calendar-off',
  'calendar-minus',
  'calendar-minus-2',
  'calendar-heart',
  'calendar-fold',
  'calendar-days',
  'calendar-cog',
  'calendar-clock',
  'calendar-check',
  'calendar-check-2',
  'calendar-arrow-up',
  'calendar-arrow-down',
  'calendar-1',
  'calculator',
  'cake',
  'cake-slice',
  'cable',
  'cable-car',
  'bus',
  'bus-front',
  'building',
  'building-2',
  'bug',
  'bug-play',
  'bug-off',
  'bubbles',
  'brush',
  'brush-cleaning',
  'bring-to-front',
  'briefcase',
  'briefcase-medical',
  'briefcase-conveyor-belt',
  'briefcase-business',
  'brick-wall',
  'brick-wall-shield',
  'brick-wall-fire',
  'brain',
  'brain-cog',
  'brain-circuit',
  'brackets',
  'braces',
  'boxes',
  'box',
  'bow-arrow',
  'bottle-wine',
  'bot',
  'bot-off',
  'bot-message-square',
  'boom-box',
  'bookmark',
  'bookmark-x',
  'bookmark-plus',
  'bookmark-minus',
  'bookmark-check',
  'book',
  'book-x',
  'book-user',
  'book-up',
  'book-up-2',
  'book-type',
  'book-text',
  'book-search',
  'book-plus',
  'book-open',
  'book-open-text',
  'book-open-check',
  'book-minus',
  'book-marked',
  'book-lock',
  'book-key',
  'book-image',
  'book-heart',
  'book-headphones',
  'book-down',
  'book-dashed',
  'book-copy',
  'book-check',
  'book-audio',
  'book-alert',
  'book-a',
  'bone',
  'bomb',
  'bolt',
  'bold',
  'bluetooth',
  'bluetooth-searching',
  'bluetooth-off',
  'bluetooth-connected',
  'blocks',
  'blinds',
  'blend',
  'bitcoin',
  'birdhouse',
  'bird',
  'biohazard',
  'binoculars',
  'binary',
  'bike',
  'biceps-flexed',
  'between-vertical-start',
  'between-vertical-end',
  'between-horizontal-start',
  'between-horizontal-end',
  'bell',
  'bell-ring',
  'bell-plus',
  'bell-off',
  'bell-minus',
  'bell-electric',
  'bell-dot',
  'beer',
  'beer-off',
  'beef',
  'bed',
  'bed-single',
  'bed-double',
  'bean',
  'bean-off',
  'beaker',
  'battery',
  'battery-warning',
  'battery-plus',
  'battery-medium',
  'battery-low',
  'battery-full',
  'battery-charging',
  'bath',
  'baseline',
  'barrel',
  'barcode',
  'banknote',
  'banknote-x',
  'banknote-arrow-up',
  'banknote-arrow-down',
  'bandage',
  'banana',
  'ban',
  'balloon',
  'baggage-claim',
  'badge',
  'badge-x',
  'badge-turkish-lira',
  'badge-swiss-franc',
  'badge-russian-ruble',
  'badge-question-mark',
  'badge-pound-sterling',
  'badge-plus',
  'badge-percent',
  'badge-minus',
  'badge-japanese-yen',
  'badge-info',
  'badge-indian-rupee',
  'badge-euro',
  'badge-dollar-sign',
  'badge-check',
  'badge-cent',
  'badge-alert',
  'backpack',
  'baby',
  'axis-3d',
  'axe',
  'award',
  'audio-waveform',
  'audio-lines',
  'atom',
  'at-sign',
  'asterisk',
  'arrows-up-from-line',
  'arrow-up',
  'arrow-up-z-a',
  'arrow-up-wide-narrow',
  'arrow-up-to-line',
  'arrow-up-right',
  'arrow-up-narrow-wide',
  'arrow-up-left',
  'arrow-up-from-line',
  'arrow-up-from-dot',
  'arrow-up-down',
  'arrow-up-a-z',
  'arrow-up-1-0',
  'arrow-up-0-1',
  'arrow-right',
  'arrow-right-to-line',
  'arrow-right-left',
  'arrow-right-from-line',
  'arrow-left',
  'arrow-left-to-line',
  'arrow-left-right',
  'arrow-left-from-line',
  'arrow-down',
  'arrow-down-z-a',
  'arrow-down-wide-narrow',
  'arrow-down-up',
  'arrow-down-to-line',
  'arrow-down-to-dot',
  'arrow-down-right',
  'arrow-down-narrow-wide',
  'arrow-down-left',
  'arrow-down-from-line',
  'arrow-down-a-z',
  'arrow-down-1-0',
  'arrow-down-0-1',
  'arrow-big-up',
  'arrow-big-up-dash',
  'arrow-big-right',
  'arrow-big-right-dash',
  'arrow-big-left',
  'arrow-big-left-dash',
  'arrow-big-down',
  'arrow-big-down-dash',
  'armchair',
  'archive',
  'archive-x',
  'archive-restore',
  'apple',
  'app-window',
  'app-window-mac',
  'aperture',
  'anvil',
  'antenna',
  'annoyed',
  'angry',
  'anchor',
  'amphora',
  'ampersands',
  'ampersand',
  'ambulance',
  'align-vertical-space-between',
  'align-vertical-space-around',
  'align-vertical-justify-start',
  'align-vertical-justify-end',
  'align-vertical-justify-center',
  'align-vertical-distribute-start',
  'align-vertical-distribute-end',
  'align-vertical-distribute-center',
  'align-start-vertical',
  'align-start-horizontal',
  'align-horizontal-space-between',
  'align-horizontal-space-around',
  'align-horizontal-justify-start',
  'align-horizontal-justify-end',
  'align-horizontal-justify-center',
  'align-horizontal-distribute-start',
  'align-horizontal-distribute-end',
  'align-horizontal-distribute-center',
  'align-end-vertical',
  'align-end-horizontal',
  'align-center-vertical',
  'align-center-horizontal',
  'album',
  'alarm-smoke',
  'alarm-clock',
  'alarm-clock-plus',
  'alarm-clock-off',
  'alarm-clock-minus',
  'alarm-clock-check',
  'airplay',
  'air-vent',
  'activity',
  'accessibility',
  'a-large-small',
  'a-arrow-up',
  'a-arrow-down',
];
